import Immutable from 'immutable';
import {isMobile} from 'utils';
import {languages} from 'locale';
import {getShareUrl} from 'share';
import {ActionTypes as SearchActionTypes} from 'store/search/actions';
import {ActionTypes} from './actions';

const getLanguageConfig = (languageCode) => {
    const languageConfig = languages.find(language => language.value === languageCode);
    if (!languageConfig) return {};
    return {
        language: languageConfig.value,
        rtl: Boolean(languageConfig.rtl),
        noBold: Boolean(languageConfig.noBold),
    };
};

const parseCSSSize = value => {
    const re = /([\d.]+)(px|em|rem)$/;
    const match = String(value).match(re);
    if (match) return match[0];
};

export const defaults = Immutable.fromJS({
    language: 'autodetect',

    theme: 'blue',

    captionsFontSize: '',
    transcriptFontSize: '',

    onlySeo: false,
    disabled: false,
    transcriptEnabled: true,
    searchEnabled: true,
    heatmapEnabled: true,
    captionsEnabled: true,
    transcriptVisible: true,
    captionsVisible: false,
    heatmapVisible: true,
    speakersVisible: true,
    printEnabled: false,
    downloadEnabled: false,
    shareEnabled: false,
    wordHighlight: false,
    wordHighlightOption: false,

    domContainer: '',
    expandHeight: false,

    startTime: 0,

    searchPosition: 'above',
    searchQuery: '',
    searchVariable: '',
    searchTypes: [],
    searchPartial: false,

    jobId: '',
    shortCode: '',
    mdpsVersion: null,

    elementListManifest: null,
    captionsManifest: null,

    videoId: '',
    provider: '',
    panopto_host: '',
    playerId: '',
    accountId: '',

    embedType: '',

    wrapperId: '',

    videoTitle: '',

    hideCielo24Logo: false,
    disableCielo24Link: false,
    clientLogoImage: '',
    clientLogoHref: '',
    sponsorLogoImage: '',
    sponsorLogoHref: '',

    debugMessages: false,
    debugPerformance: false,
});

export const whitelist = [...defaults.keys()];
export const whitelistOptions = (options) => Immutable.fromJS(options).filter((_, key) => defaults.has(key));

export const initial = Immutable.fromJS({
    languages,
    rtl: false,
    noBold: false,
    shareUrl: '',
    shareTime: true,
    shareSearch: false,
}).merge(defaults);

export const reducer = (state = initial, action) => {
    switch (action.type) {
        case ActionTypes.PARSE_OPTIONS:
            let options = whitelistOptions(action.options);

            const searchPosition = options.get('searchPosition');
            if (!['above', 'below'].includes(searchPosition)) options = options.delete('searchPosition');

            const language = options.get('language');
            options = options.delete('language');
            state = state.mergeDeep(getLanguageConfig(language));

            const searchTypes = options.get('searchTypes');
            if (typeof searchTypes === 'string') {
                options = options.set('searchTypes', Immutable.List([searchTypes]));
            }

            const domContainer = options.get('domContainer');
            if (domContainer && !['.', '#', '['].includes(domContainer[0])) {
                options = options.set('domContainer', `#${domContainer}`);
            }

            ['transcript', 'captions'].forEach(type => {
                const key = `${type}FontSize`;
                if (!parseCSSSize(options.get(key))) options = options.delete(key);
            });

            state = state.mergeDeep(options);

            if (!state.get('captionsEnabled')) state = state.set('captionsVisible', false);
            if (!state.get('transcriptEnabled')) state = state.set('transcriptVisible', false);
            if (!state.get('heatmapEnabled')) state = state.set('heatmapVisible', false);

            return state;

        case ActionTypes.SET_LANGUAGE:
            state = state.mergeDeep(getLanguageConfig(action.language));
            return state;

        case ActionTypes.TOGGLE_HEATMAP:
            state = state.set('heatmapVisible', action.visible);
            return state;

        case ActionTypes.TOGGLE_TRANSCRIPT:
            state = state.set('transcriptVisible', action.visible);
            if (isMobile() && action.visible && state.get('captionsVisible')) {
                state = state.set('captionsVisible', false);
            }
            return state;

        case ActionTypes.TOGGLE_CAPTIONS:
            state = state.set('captionsVisible', action.visible);
            if (isMobile() && action.visible && state.get('transcriptVisible')) {
                state = state.set('transcriptVisible', false);
            }
            return state;

        case ActionTypes.TOGGLE_SPEAKERS:
            state = state.set('speakersVisible', action.visible);
            return state;

        case ActionTypes.TOGGLE_WORD_HIGHLIGHT:
            state = state.set('wordHighlight', action.visible);
            return state;

        case ActionTypes.TOGGLE_SHARE_TIME:
            state = state.set('shareTime', !state.get('shareTime'));
            if (state.get('shareTime')) state = state.set('shareSearch', false);
            state = state.set('shareUrl', getShareUrl(state));
            return state;

        case ActionTypes.TOGGLE_SHARE_SEARCH:
            state = state.set('shareSearch', !state.get('shareSearch'));
            if (state.get('shareSearch')) state = state.set('shareTime', false);
            state = state.set('shareUrl', getShareUrl(state));
            return state;

        case ActionTypes.UPDATE_SHARE_URL:
            state = state.set('startTime', action.currentTime);
            state = state.set('shareUrl', getShareUrl(state));
            return state;

        case ActionTypes.SET_VIDEO_TITLE:
            state = state.set('videoTitle', action.videoTitle);
            return state;

        case SearchActionTypes.SET_RESULTS:
            state = state.merge({
                searchQuery: action.query,
                searchTypes: action.types,
                searchPartial: action.partial,
            });
            return state;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./scripts/store/config/reducer.js